import { DEFAULT_VALUE_SELECT_CHOISE_TIME } from "./variables"

export const formatCallTimeIso = (timeValue?: string): string | undefined => {
  // 1. Если выбрано DEFAULT_VALUE_SELECT_CHOISE_TIME или пусто -> поле callTime не отправляем вообще
  if (!timeValue || timeValue === DEFAULT_VALUE_SELECT_CHOISE_TIME) {
    return undefined
  }

  // 2. Парсим строку вида "Сегодня 15:30" или "Завтра 10:15"
  const match = timeValue.match(/^(Сегодня|Завтра)\s+(\d{2}):(\d{2})$/)
  if (!match) {
    return undefined // Если строка не подошла под формат, не отправляем поле
  }

  // eslint-disable-next-line @typescript-eslint/naming-convention, @typescript-eslint/no-unused-vars
  const [_, dayWord, hours, minutes] = match
  const targetDate = new Date()

  // 3. Если выбрано "Завтра", сдвигаем дату на +1 день вперед от текущей
  if (dayWord === "Завтра") {
    targetDate.setDate(targetDate.getDate() + 1)
  }

  const yyyy = targetDate.getFullYear()
  const mm = String(targetDate.getMonth() + 1).padStart(2, "0")
  const dd = String(targetDate.getDate()).padStart(2, "0")

  // 4. Генерируем чистый ISO формат: "2023-10-04T10:30:00"
  return `${yyyy}-${mm}-${dd}T${hours}:${minutes}:00`
}
